import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
import { StaffRoleFragmentDoc } from '../../../../staff-roles/graphql/fragments/generated/StaffRole';
export type UserListItemFragment = { createdAt: string, status: Types.UserStatusEnum, isStaff: boolean, staffRoleIds?: Array<string> | null, uniqueId: string, id: string, name?: string | null, emailId?: string | null, profilePicture?: string | null, staffRoles?: Array<{ id: string, name: string, description?: string | null, type: Types.RoleTypesEnum, metadata?: { tagColor?: string | null, configuredPermissions?: Array<string> | null } | null }> | null, properties?: { syncedFromProvider?: { id: string, iconUrl: string, name: string } | null } | null, orgRole?: { id: string, name: string } | null };


export type UserListItemFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const UserListItemFragmentDoc = /*#__PURE__*/ gql`
    fragment UserListItem on UserType {
  ...User
  createdAt
  status
  isStaff
  staffRoleIds
  uniqueId
  staffRoles {
    ...StaffRole
  }
  properties {
    syncedFromProvider {
      id
      iconUrl
      name
    }
  }
}
    `;